
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"23","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.406 11c1.055 0 1.833-.778 1.833-1.834 0-1.055-.778-1.833-1.833-1.833s-1.834.778-1.834 1.833c0 1.056.778 1.834 1.834 1.834zM17 8.25h-3.666v1.833H17V8.25zM17 11.916h-2.75v1.834H17v-1.834zM9.406 11.687c1.869 0 3.405 1.72 3.405 2.98h-6.81c0-1.26 1.535-2.98 3.405-2.98z","fill":"#7B01B5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.834 3.667H4.167c-1.011 0-1.833.77-1.833 1.718v11.23c0 .947.822 1.718 1.833 1.718h14.666c1.012 0 1.834-.77 1.834-1.719V5.385c0-.948-.822-1.718-1.834-1.718zm0 12.833l-14.667-.01V5.5l14.667.01V16.5z","fill":"#7B01B5"}})])
          )
        }
      }
    